import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCircleButtonClass } from '../../v2/buttons/CircleButton';
import HomeIcon from '../../v2/icons/HomeIcon';
import UserIcon from '../../v2/icons/UserIcon';
import PhoneIcon from '../../v2/icons/PhoneIcon';
import EmailIcon from '../../v2/icons/EmailIcon';
import LockIcon from '../../v2/icons/LockIcon';
import CogIcon from '../../v2/icons/CogIcon';
import LocationMarkerIcon from '../../v2/icons/LocationMarkerIcon';
import DollarIcon from '../../v2/icons/DollarIcon';
import TrendingUpIcon from '../../v2/icons/TrendingUpIcon';

function getIcon(iconName) {
  switch (iconName) {
    case 'home':
      return <HomeIcon />;
    case 'user':
      return <UserIcon />;
    case 'phone':
      return <PhoneIcon />;
    case 'email':
    case 'envelope':
    case 'mail':
      return <EmailIcon />;
    case 'location-marker':
    case 'map-marker':
      return <LocationMarkerIcon />;
    case 'usd':
    case 'dollar':
      return <DollarIcon size="medium" />;
    case 'trending-up':
      return <TrendingUpIcon />;
    case 'lock':
      return <LockIcon />;
    case 'billing_rep':
      return <DollarIcon size="medium" />;
    case 'operations_manager':
      return <CogIcon />;
    case 'account_manager':
      return <UserIcon />;
    default:
      return null;
  }
}

const LabelValue = (props) => {
  const isNull =
    !props.value || props.value === 'null' || props.value === 'undefined';
  const { t } = useTranslation();
  let value;
  const { children } = props;
  if (children) {
    value = children;
  } else {
    value = isNull ? t('NOT_SET') : props.value;
  }

  return (
    <div className="flex items-center mb-2 -mx-2">
      <div className="px-2 min-w-1/6">
        {props.sequence && (
          <div
            className={getCircleButtonClass({ color: 'gray', size: 'small' })}
          >
            <span className="text-gray-700">{props.sequence}</span>
          </div>
        )}
        {props.icon && (
          <div
            className={getCircleButtonClass({ color: 'gray', size: 'small' })}
          >
            {getIcon(props.icon)}
          </div>
        )}
        {!props.glyph && props.label && (
          <label className="my-0 form-label">${props.label}</label>
        )}
      </div>
      <div className="px-2 break-words overflow-hidden">
        <span className="break-words text-grey-dark">{value}</span>
      </div>
    </div>
  );
};

export default LabelValue;
